import { AlertStatusEnum } from '@src/entities/Alert/includes/schemas';
import { z } from 'zod';

export const SaveAlertSchema = z.object({
  assignedUser: z.string().optional(),
  id: z.string().optional(),
  jsonData: z.string().optional(),
  notes: z.string().optional(),
  shortDesc: z.string().optional(),
  status: AlertStatusEnum.optional(),
  triggeredAlertId: z.uuid(),
});
